import { Form, Modal } from 'antd';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
// import RegisterForm from '../../Auth/RegisterForm';
import FormProvider from './FormProvider';
import { AppDispatch } from '../../../../store/app';
import { useDispatch } from 'react-redux';
import { fetchAddProvider } from '../../../../store/ProviderSlice';

const AddProvider: React.FC<any> = (props) => {
  const { handleAddModal, openAddModal, getList } = props;
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const handleSubmit = (data: any) => {
    dispatch(fetchAddProvider(data))
      .then(() => {
        handleAddModal();
        getList();
      })
      .catch(() => {
        handleAddModal();
      });
  };
  return (
    <>
      <Modal
        open={openAddModal}
        destroyOnClose
        width={800}
        onCancel={handleAddModal}
        closeIcon={<FontAwesomeIcon icon={faTimes} />}
        footer={false}
        className="addModal"
        title={`Add Provider`}
      >
        <FormProvider
          form={form}
          handleAddProvider={handleSubmit}
        />
      </Modal>
    </>
  );
};

export default AddProvider;
